import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { EditableQuantity } from '../EditableQuantity';

interface ItemQuantityProps {
  quantity: number;
  editable?: boolean;
  /**
   * Disables the increase and decrease quantity inputs when editable is true
   */
  disabled?: boolean;
  onQuantityChange?: (newQty: number) => void;
  error?: string | null;
  disableAddButton?: boolean;
}

export const messages = defineMessages({
  quantityText: { defaultMessage: 'Quantity' },
  subtractBtnAriaLabelText: {
    defaultMessage: 'Decrease quantity by 1',
  },
  addBtnLabelText: {
    defaultMessage: 'Increase quantity by 1',
  },
  itemQuantity: {
    defaultMessage:
      '{itemQuantity} {itemQuantity, plural, one {item} other {items}}',
  },
});

export const ItemQuantity: React.FC<ItemQuantityProps> = ({
  quantity,
  editable,
  disabled,
  onQuantityChange,
  error,
  disableAddButton,
}) => {
  const intl = useIntl();
  if (editable) {
    return (
      <EditableQuantity
        label={intl.formatMessage(messages.quantityText)}
        name={intl.formatMessage(messages.quantityText)}
        subtractBtnAriaLabel={intl.formatMessage(
          messages.subtractBtnAriaLabelText
        )}
        addBtnAriaLabel={intl.formatMessage(messages.addBtnLabelText)}
        defaultValue={quantity}
        minValue={1}
        onChange={onQuantityChange || (() => {})}
        disabled={Boolean(disabled)}
        errorMsg={error || ''}
        disableAddButton={disableAddButton}
      />
    );
  }

  return (
    <Text type="body" muted>
      {intl.formatMessage(messages.itemQuantity, {
        itemQuantity: quantity,
      })}
    </Text>
  );
};
